import { render, staticRenderFns } from "./ComboFiltroEmail.vue?vue&type=template&id=c2f20170"
import script from "./ComboFiltroEmail.vue?vue&type=script&lang=ts"
export * from "./ComboFiltroEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports